import React from "react";
import SvgMapper from "../../features/common/SvgMapper";

const InterviewSetupHeader = ({activeInterview}) => {
  return (
    <header className="text-center mb-8">
      {SvgMapper.logo("mx-auto h-12 w-12 bg-blue-100 p-2 rounded-full text-blue-600")}

      <h1 className="text-3xl font-bold text-gray-900 mb-2">Interview Setup</h1>
      <p className="text-gray-600 text-lg">
        Prepare for your {activeInterview?.interview_name}
      </p>

      <div className="flex items-center justify-center space-x-4 mt-4">
        <span className="px-3 py-1 rounded-full text-sm font-medium text-yellow-600 bg-yellow-50">
          {activeInterview?.difficulty}
        </span>
        <span className="text-gray-500">•</span>
        <span className="text-gray-600">{activeInterview?.duration}</span>
      </div>
    </header>
  );
};

export default InterviewSetupHeader;
